import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, map, startWith } from 'rxjs';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { IAnyos, IPeriodos } from 'src/app/interfaces/portal-calificaciones';
import { IListaReemplazos, IReemplazos } from 'src/app/interfaces/reemplazo-docente';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { PortalCalificacionesService } from 'src/app/services/portal-calificaciones/portal-calificaciones';
import { ReemplazoDocenteService } from 'src/app/services/reemplazo-docente/reemplazo-docente.service';
import { UtilsFnService } from 'src/app/services/utils/utils-fn.service';

@Component({
  selector: 'app-view-reemplazo-docente-inicio',
  templateUrl: './view-reemplazo-docente-inicio.component.html',
  styleUrls: ['./view-reemplazo-docente-inicio.component.scss']
})
export class ViewReemplazoDocenteInicioComponent implements OnInit {
  dtOptionsDp: DataTables.Settings = { ...DatatableConfig.dtOptionsWithPopOver }
  renderTableDp: boolean = false

  filtroAnyoDp: number = 0
  filtroPeriodoDp: number = 0
  filtroSedeDp: number = 0
  filtroSeccionDp: number = 0

  listaAnyoDp: Array<number> = []
  listaPeriodoDp: any = []
  listaSedeDp: any = []
  listaSeccionDp: any = []

  filtrosCargadosDp: any = {}

  tieneErroresDp: any = {}
  submittedDp: boolean = false

  rolDaraCentralDp: boolean = false

  listaNombreDocentesDp: any = []
  searchCodDocenteFormDp = new FormControl('')
  searchNombreDocenteFormDp = new FormControl('')
  filteredNombreDocentesDp: Observable<Array<any>>
  filteredCodDocentesDp: Observable<Array<any>>

  listaReemplazosDp: Array<any> = []

  parametrosFormDp = this.formBuilder.group({
    anyo: ['0', [Validators.required]],
    periodo: ['0', [Validators.required]],
    sede: ['0'],
    seccion: ['0'],
    idDocente: [''],
    nombreDocente: ['']
  })

  alertaCreacionReemplazoDocenteDp: string = ''

  constructor(
    private _reemplazoDocente: ReemplazoDocenteService,
    private _portalServices: PortalCalificacionesService,
    private _perfilamiento: PerfilamientoService,
    private router: Router,
    private formBuilder: FormBuilder,
    private _utilsFn: UtilsFnService
  ) {
    let user = this._perfilamiento.getUsuario()
    if ( user.nombreRol === 'R_DARA_C' ) this.rolDaraCentralDp = true

    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if (routerData?.filtros) {
      this.filtrosCargadosDp = routerData.filtros
    }
    if ( routerData?.reemplazoDocenteCreado ) {
      this.alertaCreacionReemplazoDocenteDp = `Se ha creado con éxito la configuración del reemplazo del docente ${routerData?.nombreDocente}`
      setTimeout(() => {
        this.alertaCreacionReemplazoDocenteDp = ''
      }, (15 * 1000))
    }

    if ( routerData?.reemplazoDocenteEditado ) {
      this.alertaCreacionReemplazoDocenteDp = `Se ha editado con éxito la configuración del reemplazo del docente ${routerData?.nombreDocente}`
      setTimeout(() => {
        this.alertaCreacionReemplazoDocenteDp = ''
      }, (15 * 1000))
    }

    this.filteredCodDocentesDp = this.searchCodDocenteFormDp.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'cod')),
    )
    this.filteredNombreDocentesDp = this.searchNombreDocenteFormDp.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'nombre')),
    )

    this.obtenerAnyos()
  }

  ngOnInit(): void {
    this.dtOptionsDp = { ...DatatableConfig.dtOptionsWithPopOver }
    setTimeout(() => {
      this.renderTableDp = true
    }, 500);
  }

  displayFnCodDocentes(docente: any): string {
    return docente?.codigo ?? ''
  }

  displayFnNombreDocentes(docente: any): string {
    return docente?.primerNombre ? `${docente?.primerNombre ?? ''} ${docente?.apellidoPat ?? ''} ${docente?.apellidoMat ?? ''}` : ''
  }

  private _normalizeValue(value: string): string {
    return value?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, '')
  }

  private _filter(value: string, type: string): string[] {
    if (typeof value != 'string') {
      return []
    }
    const filterValue = this._normalizeValue(value)
    if ( type === 'cod' ) {
      return this.listaNombreDocentesDp.filter((docente: any) => this._normalizeValue(docente?.codigo)?.includes(filterValue) )
    } else {
      return this.listaNombreDocentesDp.filter((docente: any) => this._normalizeValue(`${docente?.primerNombre} ${docente?.apellidoPat} ${docente?.apellidoMat}`)?.includes(filterValue) )
    }
  }

  keypressNumber(event: any) {
    return this._utilsFn.keypressNumber(event)
  }

  resetearValidacion(tipo: string = 'default') {
    this.submittedDp = false
    this.tieneErroresDp["anyo"] = false
    this.tieneErroresDp["periodo"] = false
    this.tieneErroresDp["sede"] = false
    this.tieneErroresDp["idDocente"] = false
    if ( tipo === 'inputSearchCodDocente' || tipo === 'inputSearchNombreDocente' ) {
      this.seleccionDocente(tipo)
    }
  }

  limpiarFiltros() {
    this.filtroAnyoDp = 0
    this.filtroPeriodoDp = 0
    this.listaPeriodoDp = []
    this.filtroSedeDp = 0
    this.listaSedeDp = []
    this.searchCodDocenteFormDp.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    this.searchNombreDocenteFormDp.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    this.listaNombreDocentesDp = []
    this.filteredCodDocentesDp = this.searchCodDocenteFormDp.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'cod')),
    )
    this.filteredNombreDocentesDp = this.searchNombreDocenteFormDp.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', 'nombre')),
    )

    this.renderTableDp = false
    this.listaReemplazosDp = []
    setTimeout(() => {
      this.renderTableDp = true
    }, 500);
  }

  seleccionDocente(tipo: string) {
    const dataDocente: any = typeof this.searchCodDocenteFormDp.getRawValue() === 'object' ? this.searchCodDocenteFormDp.getRawValue() : this.searchNombreDocenteFormDp.getRawValue()
    if ( typeof this.searchCodDocenteFormDp.getRawValue() === 'object' && tipo === 'inputSearchCodDocente' && typeof this.searchNombreDocenteFormDp.getRawValue() !== 'object' ) {
      this.searchNombreDocenteFormDp.patchValue(dataDocente, {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    }
    if ( typeof this.searchNombreDocenteFormDp.getRawValue() === 'object' && tipo === 'inputSearchNombreDocente' && typeof this.searchCodDocenteFormDp.getRawValue() !== 'object' ) {
      this.searchCodDocenteFormDp.patchValue(dataDocente, {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    }

    if ( tipo === 'inputSearchCodDocente' && typeof this.searchCodDocenteFormDp.getRawValue() !== 'object' && typeof this.searchNombreDocenteFormDp.getRawValue() === 'object' ) {
      this.searchNombreDocenteFormDp.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    }
    if ( tipo === 'inputSearchNombreDocente' && typeof this.searchNombreDocenteFormDp.getRawValue() !== 'object' && typeof this.searchCodDocenteFormDp.getRawValue() === 'object' ) {
      this.searchCodDocenteFormDp.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
    }
  }

  fnCasePeriodo(): void {
    this.obtenerSedes(this.filtroAnyoDp, this.filtroPeriodoDp, 0);
    this.verificarYObtenerDocentesParaPeriodoDp();
  }
  
  fnCaseSede(): void {
    this.verificarYObtenerDocentesParaSedeDp();
  }
  
  verificarYObtenerDocentesParaPeriodoDp(): void {
    if (Object.keys(this.filtrosCargadosDp).length === 0 || (!this.filtrosCargadosDp?.periodoId && this.filtrosCargadosDp?.sedeId === 0)) {
      this.obtenerDocentes(this.filtroAnyoDp, this.filtroPeriodoDp);
    }
  }
  
  verificarYObtenerDocentesParaSedeDp(): void {
    if (Object.keys(this.filtrosCargadosDp).length === 0 || (!this.filtrosCargadosDp?.sedeId && this.filtrosCargadosDp?.seccionId === 0)) {
      this.obtenerDocentes(this.filtroAnyoDp, this.filtroPeriodoDp, this.filtroSedeDp);
    }
  }

  cargarFiltros(filtro: string): void {
    if ( this.filtroAnyoDp === 0 && this.filtroPeriodoDp === 0 ) {
      return
    }

    switch (filtro) {
      case "anyo":
        this.obtenerPeriodos(this.filtroAnyoDp)
        break;
      case "periodo":
        this.fnCasePeriodo()
        break;
      case "sede":
        this.fnCaseSede()
        break;
      case "seccion":
        this.obtenerDocentes(this.filtroAnyoDp, this.filtroPeriodoDp, this.filtroSedeDp, this.filtroSeccionDp)
        break;
      default:
        break;
    }
  }

  obtenerAnyos() {
    this._portalServices.obtenerListaAnhos(true).subscribe((res: IAnyos) => {
      this.listaAnyoDp = res.anyos
      if ( this.filtrosCargadosDp?.anyo ) {
        this.filtroAnyoDp = this.filtrosCargadosDp?.anyo
        delete this.filtrosCargadosDp.anyo
      }
    })
  }

  obtenerDocentes(anyo: number, periodoId: number, sedeId: number = 0, seccionId: number = 0): void {
    this._reemplazoDocente.obtenerListaDocentesBackoffice(anyo, periodoId, sedeId, seccionId).subscribe((res: any) => {
      this.listaNombreDocentesDp = res

      this.filteredCodDocentesDp = this.searchCodDocenteFormDp.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '', 'cod')),
      )
      this.filteredNombreDocentesDp = this.searchNombreDocenteFormDp.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '', 'nombre')),
      )

      if ( this.filtrosCargadosDp?.dataDocente ) {
        this.searchCodDocenteFormDp.patchValue(this.filtrosCargadosDp.dataDocente, {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
        delete this.filtrosCargadosDp.dataDocente
      }

      if ( !this.filtrosCargadosDp?.dataDocente && this.filtroSeccionDp !== 0 && this.listaNombreDocentesDp.length > 0 ) {
        this.searchCodDocenteFormDp.patchValue(this.listaNombreDocentesDp[0], {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
        this.searchNombreDocenteFormDp.patchValue(this.listaNombreDocentesDp[0], {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: false})
      } else {
        this.searchCodDocenteFormDp.patchValue(' ', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
        this.searchCodDocenteFormDp.patchValue('', {emitViewToModelChange: true, emitModelToViewChange: true, emitEvent: true})
      }
    })
  }

  obtenerPeriodos(filtroAnyo: number): void {
    this.filtroPeriodoDp = 0
    this.filtroSeccionDp = 0
    this.filtroSedeDp = 0
    this.listaSedeDp = []
    this.listaSeccionDp = []

    if ( filtroAnyo !== 0 ) {
      this.tieneErroresDp["anyo"] = false
      this._portalServices.obtenerListaPeriodos(filtroAnyo, true).subscribe(
        (res: IPeriodos) => {
          this.listaPeriodoDp = res.periodos
          if (this.filtrosCargadosDp?.periodoId) {
            this.filtroPeriodoDp = this.filtrosCargadosDp.periodoId
            if ( this.filtrosCargadosDp.hasOwnProperty("dataDocente") ) {
              // this.obtenerDocentes(this.filtroAnyoDp, this.filtroPeriodoDp)
            }
            delete this.filtrosCargadosDp.periodoId
          }
        }
      )
    }
  }

  obtenerSedes(anyo: number = 0, periodoId: number = 0, funcionarioId: number = 0): void {
    this.filtroSeccionDp = 0
    this.filtroSedeDp = 0
    this.listaSedeDp = []
    this.listaSeccionDp = []
    this._portalServices.obtenerListaSedesBackoffice(anyo, periodoId, funcionarioId).subscribe((res: any) => {
      this.listaSedeDp = res
      if (this.filtrosCargadosDp?.sedeId) {
        this.filtroSedeDp = this.filtrosCargadosDp.sedeId
        delete this.filtrosCargadosDp.sedeId
      }
    })
  }

  obtenerSecciones(anyo: number = 0, periodoId: number = 0, sedeId: number = 0, docenteId: number = 0): void {
    this._portalServices.obtenerListaSeccionesBackoffice(anyo, periodoId, sedeId, docenteId).subscribe((res: any) => {
      this.listaSeccionDp = res
      if (this.filtrosCargadosDp?.seccionId) {
        this.filtroSeccionDp = this.filtrosCargadosDp.seccionId
        delete this.filtrosCargadosDp.seccionId
      }
    })
  }

  fechaValidaEliminar(reemplazo: IReemplazos): boolean {
    let dateTerminoArray = reemplazo.fechaTermino.split('/');
    let convertedTerminoDate = new Date(dateTerminoArray[1]+'-'+dateTerminoArray[0]+' '+dateTerminoArray[2]);
    return convertedTerminoDate >  new Date()
  }

  actualizarLista(): void {
    this.submittedDp = true
    const dataDocente: any = typeof this.searchCodDocenteFormDp.getRawValue() === 'object' ? this.searchCodDocenteFormDp.getRawValue() : this.searchNombreDocenteFormDp.getRawValue()
    if ( this.filtroAnyoDp === 0 ) this.tieneErroresDp["anyo"] = true
    if ( this.filtroPeriodoDp === 0 ) this.tieneErroresDp["periodo"] = true
    if ( this.filtroSedeDp === 0 && !this.rolDaraCentralDp ) this.tieneErroresDp["sede"] = true
    const filtrosConErrores = Object.values(this.tieneErroresDp).filter(value => value === true)
    if ( filtrosConErrores.length > 0 ) {
      return
    }
    this.renderTableDp = false
    this._reemplazoDocente.getListaReemplazoDocentes(this.filtroAnyoDp, this.filtroPeriodoDp, this.filtroSedeDp, dataDocente.funcionarioId).subscribe(
      (res: IListaReemplazos) => {
        this.listaReemplazosDp = res.reemplazos
        this.renderTableDp = true
      }, err => {
        this.listaReemplazosDp = []
        this.renderTableDp = true
      }
    )
  }

  navToPortalDocente(): void {
    const dataDocente: any = typeof this.searchCodDocenteFormDp.getRawValue() === 'object' ? this.searchCodDocenteFormDp.getRawValue() : this.searchNombreDocenteFormDp.getRawValue()
    this.router.navigate(['/portal-calificacion'], {
      state: {
        data: {
          filtros: {
            anyo: this.filtroAnyoDp,
            periodoId: this.filtroPeriodoDp,
            sedeId: this.filtroSedeDp,
            docenteId: dataDocente.funcionarioId, // 14599215
            seccionId: this.filtroSeccionDp,
            dataDocente: dataDocente
          }
        }
      }
    })
  }

  navToCrearReemplazoDocente(): void {
    this.router.navigate(['/reemplazo-docente-crear'])
  }

  navToEditarReemplazoDocente(reemplazo:any): void {
    this.router.navigate(['/reemplazo-docente-editar'], { state: { data: { reemplazo: reemplazo}}})
  }

  camposRequeridos(): boolean {
    const dataDocente: any = this.searchCodDocenteFormDp.getRawValue()
    return this.filtroAnyoDp !== 0 && this.filtroPeriodoDp !== 0 && (typeof dataDocente === 'object')
  }

  dataEliminar: any = null
  alertaExitosa: string = ''
  infoModalTitulo: string = ''
  infoModalTexto: string = ''

  eliminarReemplazo(reemplazo: object){
    this.dataEliminar = reemplazo
    document.getElementById('modalEliminarBtn')?.click()
  }

  confirmarEliminar() {
    this._reemplazoDocente.deleteReemplazoDocente(this.dataEliminar.idReemplazo).subscribe(
      (res: any) => {
        if ( res.error === null ) {
          this.mostrarAlertaExito(`Se ha eliminado con éxito la configuración del reemplazo del docente ${this.dataEliminar.nombreDocente ? this.dataEliminar.nombreDocente : ''}`)
          this.actualizarLista()
        } else if (res.codigo !== 200 && res.codigo !== 404) {
          this.mostrarInfoModal('Error', res?.error?.mensaje ? res.error.mensaje : 'Hubo un error en los servicios.')
        }
      }, (err: any) => {
        // this.mostrarInfoModal('Error', 'Hubo un error en los servicios')
      }
    )

  }

  mostrarAlertaExito(texto: string) {
    this.alertaExitosa = texto
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setTimeout(() => {
      this.alertaExitosa = ''
    }, 3000);
  }

  mostrarInfoModal(titulo: string, texto: string) {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }
}
